import { SubjectAverageScore } from '@schooly/api';
import { CellParams } from '@schooly/components/data-grid';
import { PercentCell } from '@schooly/style';

import { CellColorProps, getCellTextColor } from '../colouredCells';
import { useMarkbookCellContext } from '../MarkbookCellContext';
import { AssessmentCellState, MarkbookForGroupRow, MarkbookForGroupsRow } from '../types';

type AverageCellRendererProps = {
  average: SubjectAverageScore;
  groupId: string;
  subjectId: string;
  studentRelationId: string;
  getAssessmentEntryColor?: (cellProps: CellColorProps) => string | null;
  isDisabled?: boolean;
} & CellParams<MarkbookForGroupRow | MarkbookForGroupsRow, AssessmentCellState>;

export const AverageCellRenderer = ({
  isDisabled,
  average,
  studentRelationId,
}: AverageCellRendererProps) => {
  const { getAverageCellColor } = useMarkbookCellContext();

  const color = getAverageCellColor?.({ studentRelationId, average });

  const getTextColor = () => {
    if (isDisabled) return ['common.grey6', 'common.grey6'] as [string, string];
    if (color) return getCellTextColor(color);
    return undefined;
  };

  return (
    <PercentCell
      value={average.average_score ?? null}
      canEdit={false}
      status={null}
      textColor={getTextColor()}
      backgroundColor={isDisabled ? 'background.default' : color}
    />
  );
};
